<template>
  <div class="sf-el thank-you-element">
    <BaseIcon :name="icon" :size="iconSize" class="thank-you-element__icon" />
    <div class="thank-you-element__message">
      {{ message }}
    </div>
  </div>
</template>

<script>
  import { defineComponent } from 'vue';
  import BaseIcon from '@shared/components/BaseIcon.vue';

  export default defineComponent({
    name: 'ThankYouElement',
    components: {
      BaseIcon,
    },
    props: {
      icon: {
        type: String,
        default: 'check-circle',
      },
      iconSize: {
        type: String,
        default: '48',
      },
      message: {
        type: String,
        default: 'Thank you for your submission!',
      },
    },
    setup(props) {},
  });
</script>

<style scoped lang="scss">
  .thank-you-element {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    text-align: center;

    &__icon {
      margin-bottom: 1rem;
      color: var(--cs-text-body);
    }

    &__message {
      font-size: 1.5rem;
      font-weight: 500;
      color: var(--cs-text-body);
    }
  }
</style>
